import { RouteProps } from 'react-router-dom';
import { PatientProfilePage } from '../components/pages/contact/patient-profile/patient-profile-page-with-provider';
import { Dashboard as KaynDashboard } from '../components/pages/kayn/dahsboard/dashboard';
import { PaymentsGetStarted } from '../components/pages/payments/get-started/payments-get-started';
import { PaymentsPage } from '../components/pages/payments/payments-page';
import { PaymentReport } from '../components/pages/payments/report/payment-report';

export enum PageRoutes {
  PATIENT_PROFILE = 'patient-profile',
  INSURANCE_DASHBOARD = 'insurance-dashboard',
  PAYMENTS_GET_STARTED = 'payments-get-started',
  PAYMENTS = 'payments',
  PAYMENT_REPORT = 'payment-report'
}

export const RoutePaths: Record<PageRoutes, string> = {
  [PageRoutes.PATIENT_PROFILE]: '/patient-profile/:id',
  [PageRoutes.INSURANCE_DASHBOARD]: '/insurance/dashboard',
  [PageRoutes.PAYMENTS_GET_STARTED]: '/payments/get-started',
  [PageRoutes.PAYMENTS]: '/payments',
  [PageRoutes.PAYMENT_REPORT]: '/payments/report'
};

export const PageRouterConfig: Record<PageRoutes, RouteProps> = {
  [PageRoutes.PATIENT_PROFILE]: {
    path: RoutePaths[PageRoutes.PATIENT_PROFILE],
    component: PatientProfilePage,
    exact: true
  },
  [PageRoutes.INSURANCE_DASHBOARD]: {
    path: RoutePaths[PageRoutes.INSURANCE_DASHBOARD],
    component: KaynDashboard,
    exact: true
  },
  [PageRoutes.PAYMENTS_GET_STARTED]: {
    path: RoutePaths[PageRoutes.PAYMENTS_GET_STARTED],
    component: PaymentsGetStarted,
    exact: true
  },
  [PageRoutes.PAYMENTS]: {
    path: RoutePaths[PageRoutes.PAYMENTS],
    component: PaymentsPage,
    exact: true
  },
  [PageRoutes.PAYMENT_REPORT]: {
    path: RoutePaths[PageRoutes.PAYMENT_REPORT],
    component: PaymentReport,
    exact: true
  }
};
